import { render } from "./App.vue?vue&type=template&id=4eac4146"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=4eac4146&lang=css"

import exportComponent from "/hpgdata/jenkins/workspace/kumc_hospital_front_prod/front-hospital/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__